import inventory from '@/router/inventory'
const Default = () => import('@/views/Default')
const Pricing = () => import('@/views/Pricing')
const Subscription = () => import('@/views/subscription/Subscription')
const Thankyou = () => import('@/views/subscription/Thankyou')
const Failed = () => import('@/views/subscription/Failed')
const mainRoutes = [
  {
    path: '/static',
    name: 'Static',
    component: () => import('../components/Static.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing
  },
  {
    path: '/mobile/pricing',
    name: 'Pricing',
    component: Pricing
  },
  {
    path: '/success',
    name: 'Thankyou',
    meta: { requiresAuth: true },
    component: Thankyou
  },
  {
    path: '/failed',
    name: 'Failed',
    meta: { requiresAuth: true },
    component: Failed
  },
  {
    path: '/subscription/:plan',
    name: 'Subscription',
    component: Subscription
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/user/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/user/Register.vue')
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: () => import('../views/user/ResetPassword.vue')
  },
  {
    path: '/passwordForgot',
    name: 'passwordForgot',
    component: () => import('../views/user/ForgotPassword.vue'),
    meta: {
      breadcrumbs: [{ name: 'Forgot Password' }]
    }
  },
  {
    path: '/setPassword',
    name: 'SetPassword',
    component: () => import('../views/user/SetPassword.vue'),
    meta: {
      breadcrumbs: [{ name: 'Set Password' }]
    }
  },
  {
    path: '/',
    name: 'main',
    component: () => import('../views/Index.vue'),
    meta: {
      breadcrumbs: [{ name: 'Main' }]
    }
  },
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true },
    redirect: 'inventory/categories',
    component: Default,
    children: [
      {
        path: '/warehouses',
        name: 'Warehouses',
        component: () => import('@/views/warehouses'),
        meta: {
          menuName: 'warehouses'
        },
        children: [
          {
            name: 'WarehousesList',
            path: '',
            component: () => import('@/views/warehouses/_list'),
            meta: {
              breadcrumbs: [{ name: 'Warehouses' }],
              category: 'warehouse',
              rightKey: 'warehouseView',
              menuName: 'warehouses'
            }
          },
          {
            name: 'EditWarehouse',
            path: ':id',
            component: () => import('@/views/warehouses/_edit'),
            meta: {
              breadcrumbs: [{ name: 'Warehouses' }, { name: 'Edit warehouse' }],
              category: 'warehouse',
              rightKey: 'warehouseEdit',
              menuName: 'warehouses'
            }
          }
        ]
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/Dashboard.vue'),
        meta: {
          breadcrumbs: [{ name: 'Dashboard' }],
          menuName: 'dashboard'
        }
      },
      {
        path: '/inventory',
        name: 'Inventory',
        component: () => import('../views/inventory/Inventory.vue'),
        meta: {
          breadcrumbs: [{ name: 'Inventory' }],
          category: 'inventory',
          rightKey: 'warehouseView',
          menuName: 'inventory'
        },
        children: [...inventory]
      },
      {
        path: '/item/createItem',
        name: 'CreateItem',
        component: () => import('../views/inventory/CreateItem.vue'),
        meta: {
          category: 'inventory',
          rightKey: 'itemCreate',
          menuName: 'inventory'
        }
      },
      {
        path: '/item/editItem/:id',
        name: 'EditItem',
        component: () => import('../views/inventory/EditItem.vue'),
        meta: {
          category: 'inventory',
          rightKey: 'itemEdit',
          menuName: 'inventory'
        }
      },
      {
        path: '/editFolder/:id',
        name: 'EditFolder',
        component: () => import('../views/inventory/EditFolder.vue'),
        meta: {
          category: 'inventory',
          rightKey: 'categoryEdit',
          menuName: 'inventory'
        }
      },
      {
        path: '/createFolder',
        name: 'CreateFolder',
        component: () => import('../views/inventory/CreateFolder.vue'),
        meta: {
          category: 'inventory',
          rightKey: 'categoryCreate',
          menuName: 'inventory'
        }
      },
      {
        path: '/locations',
        name: 'Locations',
        component: () => import('../views/locations/Locations.vue'),
        meta: {
          breadcrumbs: [{ name: 'Locations' }],
          // category: 'locations',
          // rightKey: 'locationCreate',
          menuName: 'locations'
        }
      },
      {
        path: '/createLocation',
        name: 'CreateLocation',
        component: () => import('../views/locations/CreateLocation.vue'),
        meta: {
          breadcrumbs: [{ name: 'Locations' }],
          // category: 'locations',
          // rightKey: 'locationCreate',
          menuName: 'locations'
        }
      },
      {
        path: '/history',
        name: 'ActivityHistory',
        component: () => import('../views/history/ActivityHistory.vue'),
        meta: {
          breadcrumbs: [{ name: 'Activity History' }],
          category: 'activity history',
          rightKey: 'activityHistory',
          menuName: 'activityhistory'
        }
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('../views/Users'),
        meta: {
          breadcrumbs: [{ name: 'Users' }],
          category: 'users',
          rightKey: 'userManagement',
          menuName: 'users'
        }
      },
      {
        path: '/adduser',
        name: 'AddUser',
        component: () => import('../views/user/InviteUsers'),
        meta: {
          breadcrumbs: [{ name: 'Users' }],
          category: 'users',
          rightKey: 'userManagement',
          menuName: 'users'
        }
      },
      {
        path: '/edit-user/:id',
        name: 'EditUser',
        component: () => import('@/views/user/editUser'),
        meta: {
          breadcrumbs: [{ name: 'Users' }],
          category: 'users',
          rightKey: 'userManagement',
          menuName: 'users'
        }
      },
      {
        path: '/userTest',
        name: 'TestUsers',
        component: () => import('@/views/user/Users')
      },
      {
        path: '/alerts',
        name: 'Alerts',
        component: () => import('../views/Alerts.vue'),
        meta: {
          category: 'alerts',
          rightKey: 'alertManagement',
          menuName: 'alerts'
        }
      },
      {
        path: '/reports',
        name: 'Reports',
        component: () => import('../views/reports/Reports.vue'),
        meta: {
          breadcrumbs: [{ name: 'Reports' }],
          category: 'reports',
          rightKey: 'reports',
          menuName: 'reports'
        },
        children: [
          {
            path: 'stock-balances-date',
            name: 'ReportStockBalancesDate',
            component: () => import('../views/reports/ReportStockBalancesDate'),
            meta: {
              breadcrumbs: [{ name: 'The stock balances for the Date' }],
              category: 'reports',
              rightKey: 'reports',
              menuName: 'reports'
            }
          },
          {
            path: 'stock-balances-range',
            name: 'ReportStockBalancesRange',
            component: () => import('../views/reports/ReportStockBalancesRange'),
            meta: {
              breadcrumbs: [{ name: 'The stock balances for the Range' }],
              category: 'reports',
              rightKey: 'reports',
              menuName: 'reports'
            }
          }
        ]
      },
      {
        path: '/integration',
        name: 'Integration',
        component: () => import('@/views/integration'),
        meta: {
          menuName: 'integration',
          rightKey: 'integrationManagement'
        },
        children: [
          {
            path: '',
            name: 'IntegrationAllSyncs',
            component: () => import('@/views/integration/allSyncs'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'select',
            name: 'IntegrationSelect',
            component: () => import('@/views/integration/select'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'sync/:id',
            name: 'IntegrationSync',
            component: () => import('@/views/integration/sync'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'sync/:system/:warehouse',
            name: 'IntegrationSyncContinue',
            component: () => import('@/views/integration/sync'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'resolve/:id',
            name: 'IntegrationResolve',
            component: () => import('@/views/integration/resolve'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'manual-sync/',
            name: 'IntegrationManualSync',
            component: () => import('@/views/integration/manualSync'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'oauth/:system',
            name: 'OAuthConfirm',
            component: () => import('@/views/integration/_oAuthConfirm'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'sync-success/',
            name: 'IntegrationSyncSuccess',
            component: () => import('@/components/integration/success'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'sync-error/',
            name: 'IntegrationSyncError',
            component: () => import('@/components/integration/error'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          },
          {
            path: 'log/:id',
            name: 'IntegrationSyncLog',
            component: () => import('@/views/integration/log'),
            meta: {
              menuName: 'integration',
              rightKey: 'integrationManagement'
            }
          }
        ]
      },
      {
        path: '/usersettings',
        name: 'UserSettings',
        component: () => import('@/views/user/UserSettings'),
        meta: {
          breadcrumbs: [{ name: 'User Settings' }],
          menuName: 'settings'
        }
      },
      {
        path: '/manage-custom-field',
        name: 'UserSettingsCustomField',
        component: () => import('@/views/customFieldsSettings/index'),
        meta: {
          rightKey: 'customFieldView',
          menuName: 'settings'
        }
      },
      {
        path: '/users-roles',
        name: 'UsersRoles',
        component: () => import('@/views/roles'),
        meta: {
          breadcrumbs: [{ name: 'Users Roles' }],
          category: 'roles',
          rightKey: 'roleManagement',
          menuName: 'settings'
        },
        children: [
          {
            path: '',
            name: 'UsersRolesList',
            component: () => import('@/views/roles/_list'),
            meta: {
              breadcrumbs: [{ name: 'Users Roles List' }],
              category: 'roles',
              rightKey: 'roleManagement',
              menuName: 'settings'
            }
          },
          {
            path: 'add',
            name: 'UsersRolesAdd',
            component: () => import('@/views/roles/_add'),
            meta: {
              breadcrumbs: [{ name: 'Users Roles Adding' }],
              category: 'roles',
              rightKey: 'roleManagement',
              menuName: 'settings'
            }
          },
          {
            path: 'edit/:id',
            name: 'UsersRolesEditing',
            component: () => import('@/views/roles/_edit'),
            meta: {
              breadcrumbs: [{ name: 'Users Roles Editing' }],
              category: 'roles',
              rightKey: 'roleManagement',
              menuName: 'settings'
            }
          }
        ]
      },
      {
        path: '/help',
        name: 'HelpCenter',
        component: () => import('../views/HelpCenter.vue'),
        meta: {
          breadcrumbs: [{ name: 'Help Center' }],
          menuName: 'help'
        }
      },
      {
        path: '/tags',
        name: 'Tags',
        component: () => import('../views/Tags.vue'),
        meta: {
          breadcrumbs: [{ name: 'Tags' }]
        }
      },
      {
        path: '/usersOld',
        name: 'UsersOld',
        component: () => import('../views/UsersOld'),
        meta: {
          breadcrumbs: [{ name: 'UsersOld' }]
        }
      },
      {
        path: '*',
        name: 'not-found',
        component: () => import('../views/NotFound.vue'),
        meta: {
          breadcrumbs: [{ name: 'Not Found' }]
        }
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('../views/NotFound')
      }
    ]
  }
]
export default mainRoutes
